import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import AllProductPage from "./pages/AllProductPage";
import DataBasePage from "./pages/DataBasePage";
import ProfilePage from "./pages/ProfilePage";
import ToolsPage from "./pages/ToolsPage";
import AssetStorage from "./pages/AssetStorage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ScrollToTop smooth color="#A847F0" />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/premium-themes" element={<AllProductPage />} />
        <Route exact path="/data-base-services" element={<DataBasePage />} />
        <Route exact path="/cloud-services" element={<ProfilePage />} />
        <Route exact path="/tools" element={<ToolsPage />} />
        <Route exact path="/asset-storage" element={<AssetStorage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
